import { httpClient } from '@/api/http-client'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'

type Params = {
  companyKey: string
  dependentKey: string
}

export const deleteDependent = async ({ companyKey, dependentKey }: Params) => {
  const response = await httpClient('accounting-dealer').delete(
    `/v3/company/${companyKey}/partner/dependent/${dependentKey}`,
  )
  return response.data
}

export const useDeleteDependent = (
  options?: UseMutationOptions<unknown, AxiosError, Params>,
) => {
  return useMutation({
    mutationFn: deleteDependent,
    ...options,
  })
}
